<template>
  <div class="content-v2">
    <div class="culture-grid-v2">
      <div
        class="culture-item"
        v-for="(item, i) in displayCultureList"
        :key="i"
        :class="{ 'has-image': item.image, 'image-right': item.imagePosition === 'right' }"
      >
        <div v-if="item.image" class="culture-image">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="culture-content">
          <div class="item-num">{{ formatIndex(i) }}</div>
          <h4>{{ item.title }}</h4>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCultureList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'

export default {
  name: 'EntStarsV2',
  data() {
    return {
      cultureList: [
        { title: '企业愿景', desc: '铸造智慧电力，开创清洁能源。', image: '', imagePosition: 'left' },
        { title: '企业宗旨', desc: '聚天下英才，创智慧未来。', image: '', imagePosition: 'right' },
        { title: '企业使命', desc: '打造电力行业一站式综合服务平台。', image: '', imagePosition: 'left' },
        { title: '核心价值观', desc: '诚信、激情、创新、和谐。', image: '', imagePosition: 'right' }
      ]
    }
  },
  created() {
    getCultureList().then(list => {
      if (!list || !list.length) {
        return
      }
      this.cultureList = list.map(item => ({
        title: item.cultureTitle,
        desc: item.cultureContent,
        image: resolveFileUrl(item.imageUrl),
        imagePosition: item.imagePosition || 'left'
      }))
    }).catch(() => {})
  },
  computed: {
    displayCultureList() {
      if (this.$langState.locale === 'en') {
        return [
          { title: 'Vision', desc: 'Build smart power and create clean energy.', image: '', imagePosition: 'left' },
          { title: 'Purpose', desc: 'Gather talents and create a smart future.', image: '', imagePosition: 'right' },
          { title: 'Mission', desc: 'Build an integrated service platform for the power industry.', image: '', imagePosition: 'left' },
          { title: 'Values', desc: 'Integrity, passion, innovation and harmony.', image: '', imagePosition: 'right' }
        ]
      }
      return this.cultureList
    }
  },
  methods: {
    formatIndex(index) {
      return String(index + 1).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.culture-grid-v2 {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.culture-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  min-height: 240px;
  padding: 42px;
  transition: all 0.4s;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.08);
    border-color: transparent;
  }

  &.has-image {
    display: grid;
    grid-template-columns: 360px minmax(0, 1fr);
    gap: 38px;
    align-items: center;
    padding: 28px 42px 28px 28px;
  }

  &.image-right {
    grid-template-columns: minmax(0, 1fr) 360px;
    padding: 28px 28px 28px 42px;

    .culture-image {
      order: 2;
    }
  }

  .culture-image {
    width: 100%;
    height: 220px;
    border-radius: 16px;
    overflow: hidden;
    background: #f1f5f9;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .culture-content {
    min-width: 0;
  }

  .item-num {
    font-size: 48px;
    font-weight: 800;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 16px;
  }

  h4 {
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    color: #64748b;
    line-height: 2;
    white-space: pre-line;
  }
}

@media (max-width: 960px) {
  .culture-item,
  .culture-item.has-image,
  .culture-item.image-right {
    grid-template-columns: 1fr;
    padding: 28px;
  }

  .culture-item.image-right .culture-image {
    order: 0;
  }
}
</style>
